/* istanbul ignore file */
import { EnumDropdown } from 'framework/form';

export const candidateTimelineRecords = {
  NOTE_CREATED: 'Note',
  RESUME_ADDED: 'Resume',
  APPLICATION_CREATED: 'Applications',
  SYSTEM_NOTE: 'System activities',
  COMMUNICATION: 'Communication',
  OFFER: 'Offer',
};

const { COMMUNICATION, APPLICATION_CREATED, ...filteredOptions } = candidateTimelineRecords;

const CandidateTimelineRecordTypeDropdown = (props: any) => {
  return <EnumDropdown {...props} options={filteredOptions} />;
};

export default CandidateTimelineRecordTypeDropdown;
